// ROLES
export const ADMIN_ROLE = 'ADMIN';
export const ENTITY_ROLE = 'ENTITY';
export const CLIENT_ROLE = 'CLIENT';

// USERS
export const USERS_PATH_ROLES = [ADMIN_ROLE];

// CERTIFICATES
export const CERTIFICATES_PATH_ROLES = [ENTITY_ROLE, CLIENT_ROLE];
export const CERTIFICATES_NEW_PATH_ROLES = [CLIENT_ROLE];

// MULTI CERTIFICATES
export const M_CERTIFICATES_PATH_ROLES = [CLIENT_ROLE];

// TASKS
export const TASKS_PATH_ROLES = [ENTITY_ROLE];
